import { extractSvgGeometry, type SvgIntrinsicGeometry } from "./svg_geometry"

export const normalizeSvgElement = (svgElement: SVGSVGElement): SvgIntrinsicGeometry | null => {
  const geometry = extractSvgGeometry(svgElement)
  if (!geometry) return null

  const { viewBox } = geometry

  svgElement.setAttribute("viewBox", `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`)
  svgElement.setAttribute("width", "100%")
  svgElement.setAttribute("height", "100%")
  svgElement.setAttribute("preserveAspectRatio", "xMidYMid meet")
  svgElement.style.display = "block"

  return geometry
}

export const normalizeSvgInContainer = (container: HTMLElement): SvgIntrinsicGeometry | null => {
  const svgElement = container.querySelector("svg") as SVGSVGElement | null
  if (!svgElement) return null
  return normalizeSvgElement(svgElement)
}
